import React from 'react';
import { format } from 'date-fns';
import { zhCN } from 'date-fns/locale';
import './CurrentRound.css';

const CurrentRound = ({ roundData, currentHeight }) => {
  if (!roundData) {
    return (
      <div className="current-round-container">
        <div className="current-round-card">
          <div className="loading">加载中...</div>
        </div>
      </div>
    );
  }

  const {
    roundNumber,
    startHeight,
    endHeight,
    startTime,
    estimatedEndTime,
    progress,
    progressPercentage,
    completedLuckyCount,
  } = roundData;

  const formatDateTime = (timestamp) => {
    return format(new Date(timestamp * 1000), 'yyyy-MM-dd HH:mm:ss', { locale: zhCN });
  };

  const formatDateTimeFromDate = (date) => {
    return format(date, 'yyyy-MM-dd HH:mm:ss', { locale: zhCN });
  };

  return (
    <div className="current-round-container">
      <h2 className="section-title">当前轮次</h2>
      <div className="current-round-card">
        <div className="round-header">
          <h3 className="round-title">当前轮次 #{roundNumber}</h3>
          <div className="lucky-progress">{completedLuckyCount} / 7</div>
        </div>

        <div className="round-info-grid">
          <div className="info-item">
            <div className="info-label">轮次开始</div>
            <div className="info-value">
              {startTime ? formatDateTime(startTime) : '计算中...'}
            </div>
            <div className="info-sub">(区块高度: {startHeight})</div>
          </div>

          <div className="info-item">
            <div className="info-label">预计完成</div>
            <div className="info-value">
              {estimatedEndTime ? formatDateTimeFromDate(estimatedEndTime) : '计算中...'}
            </div>
            <div className="info-sub">(区块高度: {endHeight})</div>
          </div>

          <div className="info-item">
            <div className="info-label">当前区块高度</div>
            <div className="info-value info-highlight">
              <a 
                href={`https://mempool.space/block/${currentHeight}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                #{currentHeight}
              </a>
            </div>
            <div className="info-sub">进度: {progressPercentage}%</div>
          </div>
        </div>

        <div className="progress-bar-container">
          <div className="progress-bar">
            <div 
              className={`progress-fill ${progress < 48 ? 'generating' : 'locked'}`}
              style={{ width: `${progressPercentage}%` }}
            >
              <span className="progress-text">{progress} / 210</span>
            </div>
          </div>
          <div className="progress-labels">
            <span className={progress < 48 ? 'active' : ''}>
              [0, 47] 生成中 {progress < 48 && '⚡'}
            </span>
            <span className={progress >= 48 ? 'active' : ''}>
              [48, 209] 已锁定 {progress >= 48 && '🔒'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentRound;
